/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, onCtxAbort, reaction } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network/atoms'
import { deviceWalletIdsAtom } from '@root/features/secure-storage/atoms'
import { dependenciesAtom } from '@root/features/shared/dependencies'

import { walletsModelAtom, walletsModelByNetwork } from './reatom-user-wallets'

import type { WalletModel } from './reatom-wallet'

const selectedNetworkReaction = reaction((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId) {
    return
  }

  const { mainWebsocket } = ctx.get(dependenciesAtom)
  mainWebsocket.walletBalanceSubscribeAction(ctx, {
    network: network,
    delugeId: delugeId,
  })

  onCtxAbort(ctx, () => {
    if (!delugeId) {
      return
    }
    mainWebsocket.walletBalanceUnsubscribeAction(ctx, { delugeId, network })
  })
}, 'selectedNetworkReaction')

const refreshWalletsReaction = reaction((ctx) => {
  const _deviceWalletsIds = ctx.spy(deviceWalletIdsAtom)
  const network = ctx.spy(selectedNetworkAtom)
  const model = walletsModelByNetwork[network]
  const state = ctx.get(model)
  if (AsyncStateN.isSuccess(state)) {
    model.refresh(ctx)
    return
  }

  model.load(ctx)
}, 'refreshWalletsReaction')

export const initializeWalletAtoms = action((ctx) => {
  selectedNetworkReaction(ctx)
  refreshWalletsReaction(ctx)
}, 'initializeWalletAtoms')

export const walletsTotalsStateAtom = atom((ctx) => {
  const model = ctx.spy(walletsModelAtom)
  const totalBalanceNativeState = ctx.spy(model.totalBalanceNativeState)
  const totalBalanceUsdState = ctx.spy(model.totalBalanceUsdState)

  return pipe(
    AsyncStateN.combineI(
      [totalBalanceNativeState, totalBalanceUsdState],
      (native, usd) => ({ native, usd }),
    ),
  )
}, 'walletsTotalsStateAtom')

export * from './wallets-refresh'
export * from './reatom-user-wallets'
export * from './reatom-wallet'
export * from './reatom-wallet-asset'
export * from './reatom-wallet-stats'

export const startNewWalletFlowEvent = action('startWalletFlowEvent')
export const startWalletDepositFlowEvent = action<{ wallet: WalletModel }>(
  'startWalletFlowEvent',
)
export const startWalletTransferFlowEvent = action<{ wallet: WalletModel }>(
  'startWalletFlowEvent',
)
